import { renderTextLineClamp } from 'helpers';
import { OperationsListItem } from 'modules/operation/operations/types';

export const renderExecutionPlace = (item: OperationsListItem) =>
  renderTextLineClamp(item.executionPlace?.name);
